import { create } from 'zustand';

interface WalletModalState {
  visible: boolean;
  setVisible: (visible: boolean) => void;
}

const useWalletModalStore = create<WalletModalState>((set) => ({
  visible: false,
  setVisible: (visible) => set({ visible }),
}));

export default useWalletModalStore;
